import { Styles, generateClasses } from 'netline-ui';

export const mobileNavigationClasses = generateClasses('MobileNavigation', [
  'root',
  'paper',
  'header',
  'headerLine',
  'headerIcon',
  'spacer',
  'subHeader',
  'profileMenuPaper',
] as const);

const styles: Styles = ({ theme: { spacing, colors, palette } }) => ({
  [`.${mobileNavigationClasses.paper}`]: {
    width: '85vw',
  },
  [`.${mobileNavigationClasses.headerLine}`]: {
    height: spacing(2),
    backgroundColor: palette.primary[900],
  },
  [`.${mobileNavigationClasses.header}`]: {
    display: 'flex',
    backgroundColor: colors.grey[200],
    color: colors.grey[900],
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: 0.15,
    lineHeight: '24px',
    padding: spacing(3, 2),
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: spacing(1),
  },
  [`.${mobileNavigationClasses.headerIcon}`]: {
    color: palette.primary[800],
    height: spacing(5),
    width: spacing(5),
  },
  [`.${mobileNavigationClasses.spacer}`]: {
    flexGrow: 1,
  },
  '.MuiListSubheader-root': {
    color: colors.grey[600],
    fontSize: 14,
    lineHeight: '16px',
    letterSpacing: 0.1,
    padding: `${spacing(2)} ${spacing(2)} ${spacing(1)} ${spacing(2)}}`,
  },
  '.MuiListItemText-root': {
    lineHeight: '24px',
    fontSize: 16,
    letterSpacing: 0.5,
    color: colors.grey[900],
  },
});

export default styles;
